export const toggleFileType = (type, filter, setFilter, fileTypeFilter, setFileTypeFilter) => {
  let newFileTypes = [...fileTypeFilter];

  if (filter) {
    newFileTypes = newFileTypes.filter(el => el !== type);
    setFileTypeFilter([...newFileTypes]);
  } else {
    newFileTypes.push(type);
    setFileTypeFilter([...newFileTypes]);
  }

  setFilter(!filter);

  return newFileTypes;
};
